var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelemarkMark = function SvgTelemarkMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38.503 34.635"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18DFBD",
    d: "M29.224 34.202h-8.478V.432h17.756v14.22h-9.278v19.551"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.755 34.202H9.327v-19.55H0V.431h17.755z"
  })));
};
export default SvgTelemarkMark;